import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getFeature } from "../services/features";
import { IFeature, IFeatureKey } from "../types";

export const useFeatureFlag = <F extends IFeature>(
  key: IFeatureKey,
  { fallback = false, constructor = (data: IFeature) => data } = {}
) => {
  const { data, isLoading, error } = useDataQuery(
    ["featureFlag", key],
    async () => {
      try {
        const response = await getFeature<F>(key);
        return response.data;
      } catch (e) {
        throw e;
      }
    }
  );

  const isEnabled = data?.enabled ?? fallback;
  const feature = constructor(data);

  return {
    isEnabled,
    feature,
    isLoading,
    error,
  };
};
